// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rOZ9I","item1":"styles_item1__1Gpa1","item2":"styles_item2__uU-dP"};